var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.7,815.7c0-324.6,268.5-299.6,268.5-566c0,0,139.6,133.2,75.2,258c0,0,193.3-99.9,193.3-507.7 c0,0,1041.6,840.7,96.6,1198.6c0,0,64.4-124.9,43-199.8C739.8,923.9,600.2,890.6,568,807.4c-32.2-83.2,32.2-174.8,85.9-208.1 c10.7-8.3-569.1,133.2-225.5,590.9C428.4,1190.2,84.7,1140.3,84.7,815.7L84.7,815.7z M84.7,815.7"
  })));
};
export default SvgFire;